import { API_NAMES, initApi } from "../../../utils/HttpApiHelper";

const getLscTouchpoint = (orgUnitId, state, setState) => {
    if (orgUnitId.length > 0) {
        const api = initApi(API_NAMES.COMMON, state, setState);
        const orgUnitIdForUrl = encodeURIComponent(orgUnitId);
        const url = `/OrgUnit/${orgUnitIdForUrl}/LscTouchpoints`;
        return api?.executeArray ? api.executeArray(url, 'GET') : null;
    }
}

const LSCTouchpointData = { 
    getLscTouchpoint
};

export default LSCTouchpointData;